"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRoute = void 0;
var _reactRouterDom = require("react-router-dom");
// Feel free to edit hook functionality with path-related logic or
// convert to pure function
var useRoute = function useRoute() {
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var match = (0, _reactRouterDom.useRouteMatch)();
  var updatePathParams = function updatePathParams(params) {
    var newPath = (0, _reactRouterDom.generatePath)(match.path, params);
    history.push(newPath);
  };
  return {
    history: history,
    location: location,
    match: match,
    updatePathParams: updatePathParams
  };
};
exports.useRoute = useRoute;